import React from "react";

function HowItWorks() {
  const steps = [
    {
      id: "STEP 1",
      title: "Upload Your Document",
      desc: "Upload your file from phone, laptop, or Google Drive.",
      img: "/assests/step1.jpeg",
    },
    {
      id: "STEP 2",
      title: "Set Print Preference",
      desc: "Choose copies, color, and orientation settings.",
      img: "/assests/step2.jpeg",
    },
    {
      id: "STEP 3",
      title: "Set Payment Method",
      desc: "Choose your preferred payment option such as UPI or Cash.",
      img: "/assests/step3.jpeg",
    },
    {
      id: "STEP 4",
      title: "Get Your Print",
      desc: "Collect your print instantly.",
      img: "/assests/step4.jpeg",
    },
  ];

  return (
    <section id="how" className="bg-black text-white py-20 px-6 md:px-20">

      {/* Heading */}
      <div className="text-center mb-16">
        <div className="flex justify-center mb-6">
  <span className="border border-green-400 text-green-400 px-4 py-1 rounded-full text-sm flex items-center gap-2 bg-green-400/10 backdrop-blur-md">
    ⚡ How to Use?
  </span>
</div>
        <h2 className="text-3xl md:text-5xl font-bold">
          How to Use <span className="text-green-400">Our Services</span>
        </h2>

        <p className="text-gray-400 mt-3 max-w-2xl mx-auto text-sm">
          Print your documents quickly in just a few simple steps.
        </p>
      </div>

      {/* Grid Container */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

        {steps.map((step) => (
          <div
            key={step.id}
            className="flex flex-col items-center text-center"
          >

            {/* 📱 iPhone Mockup (Ab sabse upar hai) */}
            <div className="w-full flex justify-center mb-6">
              <div className="relative w-[180px] h-[370px] bg-black rounded-[35px] p-[6px] shadow-lg border border-gray-800">
                {/* Notch */}
                <div style={{
                    marginTop:"8px",
                    width:"40px",
                }} className="absolute top-1 left-1/2 -translate-x-1/2 h-[12px] bg-black rounded-full z-10"></div>

                {/* Screen */}
                <div style={{
                    padding: 5
                }} className="w-full h-full bg-white rounded-[28px] overflow-hidden">
                  <img
                    style={{
                      borderRadius: 20
                    }}
                    src={step.img}
                    alt={step.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Step Badge */}
            <div className="bg-green-400/10 text-green-400 px-3 py-1 rounded-full text-[10px] mb-2">
              {step.id}
            </div>

            {/* Title */}
            <h3 className="text-base font-semibold">
              {step.title}
            </h3>

            {/* Desc */}
            <p className="text-sm text-gray-400 mt-2">
              {step.desc}
            </p>

          </div>
        ))}

      </div>

    </section>
  );
}

export default HowItWorks;